import React from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { NotesTabNavigationParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { View } from 'react-native';

export type AddNoteOwnProps = {};

export type AddNoteProps = AddNoteOwnProps & {
    route: RouteProp<NotesTabNavigationParamList, 'add'>;
};

const AddNoteScreen: React.FC<AddNoteProps> = (props) => {
    const goBack = useGoBack();
    const { noteEditorProps, key } = useEditNote({
        noteDestination: props.route.params,
        onCreationSuccess: () => {
            goBack();
        },
    });

    return (
        <View style={{ width: '100%', height: '100%' }}>
            <NotesEditor
                key={key}
                source="notes.add-note-route"
                onCancel={() => goBack()}
                noteDestination={props.route.params}
                defaultOpenAttachmentType={props.route.params.defaultOpenAttachmentType}
                disableRecording
                {...noteEditorProps}
            />
        </View>
    );
};

export default React.memo(AddNoteScreen);
